import { createSelector } from 'reselect';
import _omit from 'lodash/omit';
import _get from 'lodash/get';

import { ENTITIES_FILTER_OPTIONS } from 'constants/entitiesOptions';

export const getAllEntities = ({ entities }) => entities.all.data;

export const getIsLoadingAll = ({ entities }) => entities.all.isLoading;

export const getEntitiesList = ({ entities }) => entities.list.data.items;

export const getEntitiesListCount = ({ entities }) => entities.list.data.count;

export const getEntity = ({ entities }) => entities.show.data;

export const getIsLoadingList = ({ entities }) => entities.list.isLoading;

export const getPaginationOptions = ({ entities }) =>
  entities.list.paginationOptions;

export const getIsAdding = ({ entities }) => entities.add.isLoading;

export const getIsUpdating = ({ entities }) => entities.update.isLoading;

export const getIsDeleting = ({ entities }) => entities.delete.isLoading;

export const getSortOptions = ({ entities }) => entities.list.sortOptions;

export const getFilterOptions = ({ entities }) => entities.list.filterOptions;

export const getFilterParams = ({ entities }) => entities.list.filterParams;

export const getIsExporting = ({ entities }) =>
  entities.partialExport.isLoading;

export const getIsImporting = ({ entities }) =>
  entities.partialImport.isLoading;

export const getImportError = ({ entities }) =>
  _get(entities, 'partialImport.error.response.data', {});

export const getFilterOptionsWithValues = createSelector(
  getFilterOptions,
  values => ({
    values,
    options: ENTITIES_FILTER_OPTIONS.map(item => _omit(item, ['value'])),
  }),
);

export const getFilteredSortOptions = createSelector(
  getSortOptions,
  getPaginationOptions,
  (sortOptions, paginationOptions) =>
    sortOptions.map(option => ({
      ...option,
      selected: option.value === paginationOptions.ordering,
    })),
);

export const getSelectedSortOption = createSelector(
  getFilteredSortOptions,
  options => options.find(option => option.selected === true),
);

export const getEntityIndex = createSelector(
  getEntitiesList,
  getEntity,
  (list, item) => {
    const index = list.findIndex(({ id }) => id === item.id);

    return index === -1 ? 0 : index;
  },
);

export const getArchivedFilterOptions = createSelector(
  getFilterOptions,
  filterOptions =>
    _omit(filterOptions.find(f => f.filterBy === 'archived'), [
      'filterBy',
      'label',
      'enabled',
    ]),
);

export const getFilterOptionsWithSelected = createSelector(
  getFilterOptions,
  getPaginationOptions,
  (filterOptions, paginationOptions) =>
    filterOptions.map(option => ({
      ...option,
      selected: option.archived === paginationOptions.archived,
    })),
);

export const getSelectedFilterOption = createSelector(
  getFilterOptionsWithSelected,
  filterOptions => filterOptions.find(option => option.selected === true),
);
